// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleTitle_container__EKu3L","iconContainer":"CollapsibleTitle_iconContainer__lf_ZO"};